import request from '@/utils/request';

const api = {
    privilegeList: "/privilege/privilegeList",
    problemList: "/problem/problemList",
    deletePrivilege: "/privilege/deletePrivilege",
    deleteProblem: "/problem/deleteProblem",
    editSome: "/payConfig/save",
    savePrivilege: "/privilege/savePrivilege",
    saveProblem: "/problem/saveProblem",
    MemberDifferent: "/admin/sys/MemberDifferent",
    saveMemberDifferent: "/admin/sys/saveMemberDifferent",
    instalmentList: "/instalment/instalmentList",
    updInterest: "/instalment/updInterest",
    getMemberInfo: "/payConfig/getMemberInfo",
    getUserRenewal: '/payConfig/getUserRenewal',
    instalment: '/instalment/instalmentList',
    payToken: '/pay/appEcpayPay',
    upgrade3DWork: '/pay/upgradeWorkTo3DWork',
}

export function privilegeList(data) {
    return request({
        url: api.privilegeList,
        method: 'post',
        data
    })
}

export function problemList(data) {
    return request({
        url: api.problemList,
        method: 'post',
        data
    })
}

export function deletePrivilege(data) {
    return request({
        url: api.deletePrivilege,
        method: 'post',
        data
    })
}

export function deleteProblem(data) {
    return request({
        url: api.deleteProblem,
        method: 'post',
        data
    })
}

export function editSome(data) {
    return request({
        url: api.editSome,
        method: 'post',
        data
    })
}

export function savePrivilege(data) {
    return request({
        url: api.savePrivilege,
        method: 'post',
        data
    })
}

export function saveProblem(data) {
    return request({
        url: api.saveProblem,
        method: 'post',
        data
    })
}

export function MemberDifferent() {
    return request({
        url: api.MemberDifferent,
        method: 'post',
    })
}

export function saveMemberDifferent(data) {
    return request({
        url: api.saveMemberDifferent,
        method: 'post',
        data
    })
}

export function instalmentList() {
    return request({
        url: api.instalmentList,
        method: 'post',
    })
}

export function updInterest(data) {
    return request({
        url: api.updInterest,
        method: 'post',
        data
    })
}

export function getMemberInfo(data) {
    return request({
        url: api.getMemberInfo,
        method: 'post',
        data
    })
}


export function getUserRenewal(data) {
    return request({
        url: api.getUserRenewal,
        method: 'post',
        data
    })
}

// 後台分期付款列表
export function getInstalmentList(data) {
    return request({
        url: api.instalment,
        method: 'post',
        data
    })
}

export function getPayToken(data) {
    return request({
        url: api.payToken,
        method: 'post',
        data
    })
}

export function getUpgrade3DWork(data) {
    return request({
        url: api.upgrade3DWork,
        method: 'post',
        data,
    })
}